import R from "ramda";
import moment from "moment";
import { store } from "store";
import { reset } from "redux-form";
import { fetchReports, submitReport } from "api/reports";
import { isValidEmail } from "utils/validators";
import { setFlashMessageAction, setFlashGenericErrorAction } from "actions/app-actions";
import { trackEventAction } from "actions/shared/tracking-actions";
import { reportFilterStringGenerator } from "api/filters-to-url-params";

export const SET_REPORTS = "actions/reports/set-reports";

export const fetchReportsAction = (accountId) => (dispatch) => {
  fetchReports(accountId)
    .then(({ reports }) => {
      dispatch({
        type: SET_REPORTS,
        data: { reports }
      });
    });
};

export const submitReportAction = () => (dispatch) => {
  const state = store.getState();
  const accountId = state.app.selectedAccount.id;
  const form = R.path(["form", "reports", "values"], state);
  const newVendors = form.vendors ? form.vendors.map(vendorData => vendorData.value) : null;
  const newCategories = form.categories ? form.categories.map(category => category.value) : null;
  const newForm = R.merge(form, { vendors: newVendors, categories: newCategories });
  if (reportFormValidationErrorMessage(form) !== null) {
    return dispatch(setFlashMessageAction(reportFormValidationErrorMessage(form), "error"));
  }
  const urlFilterString = reportFilterStringGenerator(newForm);
  const reportObject = {
    emails: form.email ? [form.email] : [],
    exportType: form.type.key,
    filter: urlFilterString,
    name: form.name || null
  };

  return submitReport(accountId, reportObject)
    .then(() => {
      dispatch(setFlashMessageAction("Report Sent! Please wait a few moments for your report to be generated."));
      dispatch(reset("reports"));
      dispatch(trackEventAction("Report submitted"));
    })
    .catch(() => {
      dispatch(setFlashGenericErrorAction());
    });
};

const reportFormValidationErrorMessage = (form) => {
  if (form === undefined) {
    return "Please fill out the form";
  }
  if (form.startDate === undefined || form.endDate === undefined) {
    return "Please provide a date range";
  }
  if (!moment(form.startDate).isValid() || !moment(form.endDate).isValid()) {
    return "Please enter a valid date";
  }
  if (form.email !== undefined && !isValidEmail(form.email)) {
    return "Please enter a valid email";
  }
  if (form.type === undefined) {
    return "Please enter a report type";
  }
  return null;
};



// WEBPACK FOOTER //
// ./src/js/actions/reports-actions.js